import { render, staticRenderFns } from "./buyer.vue?vue&type=template&id=b834b8be&scoped=true&"
import script from "./buyer.vue?vue&type=script&lang=js&"
export * from "./buyer.vue?vue&type=script&lang=js&"
import style0 from "./buyer.vue?vue&type=style&index=0&id=b834b8be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b834b8be",
  null
  
)

export default component.exports